import { o, prop } from 'ramda';
import { parseQueryParams } from './parseQueryParams';
import { isInBrowser } from './isInBrowser';

export const getBrowserQueryParam = param =>
	isInBrowser() ? o(prop(param), parseQueryParams)(window.location.search) : null;
